var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCrescentMoonDoNotDisturb = function SvgCrescentMoonDoNotDisturb(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31593_2307)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.08568 1.46196C5.31625 1.04693 5.22813 0.598689 4.95302 0.311079C4.68331 0.0291136 4.24629 -0.0852658 3.82913 0.100138C3.82213 0.103248 3.81522 0.10655 3.8084 0.110041C1.38718 1.35018 -0.21292 3.95118 0.0230154 6.85343C0.261152 10.2293 3.0942 13.0623 6.4701 13.3003C9.42026 13.5355 12.0243 11.9431 13.2125 9.51654C13.4446 9.08765 13.3217 8.63465 13.0266 8.36421C12.7347 8.09665 12.2768 8.00676 11.8613 8.23759C11.8532 8.24215 11.8452 8.24693 11.8373 8.25198C10.9786 8.80765 9.85632 9.06576 8.72832 8.91226C6.5731 8.60376 4.77509 6.85504 4.4669 4.65247C4.31306 3.4699 4.56918 2.39166 5.08568 1.46196Z",
    fill: "#615E67"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31593_2307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3333,
    height: 13.3333,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCrescentMoonDoNotDisturb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "crescent-moon-do-not-disturb.ea1f786228703392ecf19efd1e05624c.svg";